import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parseTime } from '@/utils';
import sameTypeHistoryOrder from '@/views/order/components/sameTypeHistoryOrder';
import standardCardDiscount from '@/views/order/components/standardCardDiscount‌.vue';
import orderConsumeptionTrend from '@/views/platformReport/orderConsumptionTrend.vue';
import applyForm from '../applyForm.vue';
import { auditQuotationApproval, getProjectDeliveryDetail, getProjectPassDetail, getBusinessType, getAddOrderCardType, getProjectDeliveryCardTypeInfo, getAuditProjectDeliverOrderList } from '../../api';
var createQuotationDefaults = function createQuotationDefaults() {
  return {
    business_type: '',
    card_type: '',
    money: '',
    number: '',
    budget: '',
    payment_method: '',
    description: '',
    order_rules: '',
    final_quotation: '',
    cost: '',
    time_limit: '',
    accounting_method: '',
    commission: '',
    performance: '',
    manager_remarks: '',
    vp_remarks: '',
    task_status: '',
    approver: []
  };
};
export default {
  name: 'QuotationApprovalDrawer',
  components: {
    sameTypeHistoryOrder: sameTypeHistoryOrder,
    standardCardDiscount: standardCardDiscount,
    orderConsumeptionTrend: orderConsumeptionTrend,
    applyForm: applyForm
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    id: {
      type: [String, Number],
      default: ''
    },
    projectType: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    var _this = this;
    return {
      loading: false,
      submitLoading: false,
      businessTypeList: [],
      quotationCardTypeList: [],
      quotationCommissionInfo: {},
      activeTab: 'audit',
      projectDetailLoaded: false,
      saleProjectDeliveryId: '',
      sameOrderTotal: null,
      otherOrderTotal: null,
      historySearchForm: {
        page: 1,
        pagesize: 20,
        sort: ''
      },
      historyTableData: [],
      historyPages: {},
      trendParams: {},
      drawerTrend: false,
      formData: {
        id: '',
        project_name: '',
        customer_name: '',
        create_name: '',
        organize_name: '',
        customer_nature: '',
        items: {
          quotation: createQuotationDefaults()
        }
      },
      rules: {
        'items.quotation.business_type': [{
          required: true,
          message: '请选择业务类型',
          trigger: 'change'
        }],
        'items.quotation.card_type': [{
          required: true,
          message: '请选择卡类型',
          trigger: 'change'
        }],
        'items.quotation.money': [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (/^\d+(\.\d{1,2})?$/.test(String(value))) {
              callback();
              return;
            }
            callback(new Error('请输入大于等于0的数，最多两位小数'));
          },
          trigger: 'blur'
        }],
        'items.quotation.number': [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (/^[1-9]\d*$/.test(String(value))) {
              callback();
              return;
            }
            callback(new Error('请输入大于0的正整数'));
          },
          trigger: 'blur'
        }],
        'items.quotation.budget': [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (/^\d+(\.\d{1,2})?$/.test(String(value))) {
              callback();
              return;
            }
            callback(new Error('请输入大于等于0的数，最多两位小数'));
          },
          trigger: 'blur'
        }],
        'items.quotation.payment_method': [{
          required: true,
          message: '请选择结算方式',
          trigger: 'change'
        }],
        'items.quotation.description': [{
          required: true,
          message: '请选择功能菜单描述',
          trigger: 'change'
        }],
        'items.quotation.final_quotation': [{
          required: true,
          validator: function validator(rule, value, callback) {
            var num = Number(value);
            if (/^(0|[1-9]\d*)(\.\d{1,3})?$/.test(String(value)) && num >= 0 && num <= 1) {
              callback();
              return;
            }
            callback(new Error('请输入0-1之间的数，最多三位小数'));
          },
          trigger: 'blur'
        }],
        'items.quotation.cost': [{
          required: true,
          validator: function validator(rule, value, callback) {
            var num = Number(value);
            if (/^(0|[1-9]\d{0,7})(\.\d{1,2})?$/.test(String(value)) && num >= 0 && num < 100000000) {
              callback();
              return;
            }
            callback(new Error('请输入8位以内的数字，最多两位小数'));
          },
          trigger: 'blur'
        }],
        'items.quotation.time_limit': [{
          required: true,
          message: '请选择报价单时效',
          trigger: 'change'
        }],
        'items.quotation.accounting_method': [{
          required: true,
          message: '请选择佣金核算方式',
          trigger: 'change'
        }],
        'items.quotation.commission': [{
          validator: function validator(rule, value, callback) {
            // 初审置灰仅展示不校验，复审必填
            if (!_this.isSecondApproval) {
              callback();
              return;
            }
            var num = Number(value);
            if (/^(0|[1-9]\d*)(\.\d{1,2})?$/.test(String(value)) && num >= 0 && num <= 100) {
              callback();
              return;
            }
            callback(new Error('请输入0-100之间的数，最多两位小数'));
          },
          trigger: 'blur'
        }],
        'items.quotation.performance': [{
          validator: function validator(rule, value, callback) {
            // 初审置灰仅展示不校验，复审必填
            if (!_this.isSecondApproval) {
              callback();
              return;
            }
            var num = Number(value);
            if (/^(0|[1-9]\d*)(\.\d{1,2})?$/.test(String(value)) && num >= 0 && num <= 500) {
              callback();
              return;
            }
            callback(new Error('请输入0-500之间的数，最多两位小数'));
          },
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    inputName: function inputName() {
      return this.formData.create_name + (this.formData.organize_name ? '/' + this.formData.organize_name : '');
    },
    // 当前待审节点：items.quotation.approver 中 status=1 的记录，'1'-总经理初审 '2'-VP复审
    approverType: function approverType() {
      var record = (this.formData.items.quotation.approver || []).find(function (i) {
        return String(i.status) === '1';
      });
      return record ? String(record.type) : null;
    },
    isFirstApproval: function isFirstApproval() {
      return this.approverType === '1';
    },
    isSecondApproval: function isSecondApproval() {
      return this.approverType === '2';
    },
    // 仅个性化项目评估（启动会）展示项目详情
    showProjectDetailTab: function showProjectDetailTab() {
      return String(this.projectType) === '1';
    },
    // 折扣不等于 1 时字段名标红
    discountLabelRed: function discountLabelRed() {
      var value = this.formData.items.quotation.final_quotation;
      if (value === '' || value === null || value === undefined) return false;
      return Number(value) !== 1;
    },
    // 服务费成本大于 0 时字段名标红
    costLabelRed: function costLabelRed() {
      return Number(this.formData.items.quotation.cost) > 0;
    },
    // 功能菜单描述为个性化卡规则时字段名标红
    descriptionLabelRed: function descriptionLabelRed() {
      return this.formData.items.quotation.description === '2';
    },
    // 客户类型为三类客户时字段名标红
    customerNatureLabelRed: function customerNatureLabelRed() {
      return this.formData.customer_nature === '2';
    },
    // 复审时佣金核算方式为人工核算，字段名标红
    accountingLabelRed: function accountingLabelRed() {
      return this.isSecondApproval && this.formData.items.quotation.accounting_method === '2';
    },
    // 备注有值时字段名标红
    orderRulesLabelRed: function orderRulesLabelRed() {
      var value = this.formData.items.quotation.order_rules;
      return value !== '' && value !== null && value !== undefined;
    },
    // 复审时折扣档命中 VP 审批（审核级别=2），佣金比例/计入业绩字段名标红
    commissionLabelRed: function commissionLabelRed() {
      return this.isSecondApproval && String(this.quotationCommissionInfo.audit_level) === '2';
    },
    showCustomerNature: function showCustomerNature() {
      return this.formData.customer_nature !== '' && this.formData.customer_nature != null;
    },
    vpRemarksShow: function vpRemarksShow() {
      return this.formData.items.quotation.vp_remarks !== '';
    },
    // 总点数 = 售卡金额 / 折扣
    totalPoints: function totalPoints() {
      var _this$formData$items$ = this.formData.items.quotation,
        money = _this$formData$items$.money,
        final_quotation = _this$formData$items$.final_quotation;
      var discount = Number(final_quotation);
      if (money === '' || !discount || discount <= 0) return '';
      return (Number(money) / discount).toFixed(2);
    }
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.loadDetail();
      }
    },
    // 卡类型变化（详情回填或用户切换）时重拉佣金信息
    'formData.items.quotation.card_type': function formDataItemsQuotationCard_type() {
      this.loadQuotationCommissionInfo();
    }
  },
  created: function created() {
    this.getBusinessTypeList({
      source: 9
    });
  },
  methods: {
    loadDetail: function loadDetail() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var obj, res, data, quotation, savedCardType, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _this2.loading = true;
              _this2.quotationCommissionInfo = {};
              _context.p = 1;
              obj = {
                id: _this2.id,
                get_group: 1,
                task_type: '9'
              };
              if (!(_this2.projectType == 1)) {
                _context.n = 3;
                break;
              }
              _context.n = 2;
              return getProjectPassDetail(obj);
            case 2:
              _t = _context.v;
              _context.n = 5;
              break;
            case 3:
              _context.n = 4;
              return getProjectDeliveryDetail(obj);
            case 4:
              _t = _context.v;
            case 5:
              res = _t;
              data = res.data || {};
              _this2.activeTab = 'audit';
              _this2.projectDetailLoaded = false;
              _this2.saleProjectDeliveryId = data.id || data.project_delivery_id || '';
              _this2.sameOrderTotal = null;
              _this2.otherOrderTotal = null;
              _this2.historyTableData = [];
              _this2.historyPages = {};
              _this2.fetchHistoryTotals();
              quotation = _objectSpread(_objectSpread({}, createQuotationDefaults()), data.items && data.items.quotation || {});
              Object.keys(quotation).forEach(function (key) {
                if (quotation[key] === null || quotation[key] === undefined) {
                  quotation[key] = '';
                }
              });
              if (quotation.accounting_method !== '') {
                quotation.accounting_method = String(quotation.accounting_method);
              }
              // 报价单时效默认取审批当天 + 30 天，后端已回填时以后端值为准
              if (!quotation.time_limit) {
                quotation.time_limit = _this2.getDefaultTimeLimit();
              }
              _this2.formData = {
                id: data.id,
                project_name: data.project_name || '',
                customer_name: data.customer_name || '',
                create_name: data.create_name || '',
                organize_name: data.organize_name || '',
                customer_nature: data.customer_nature === null || data.customer_nature === undefined ? '' : String(data.customer_nature),
                items: {
                  quotation: quotation
                }
              };
              _this2.quotationCardTypeList = [];
              if (quotation.business_type) {
                savedCardType = quotation.card_type;
                _this2.changeBusinessType();
                if (savedCardType) {
                  _this2.$nextTick(function () {
                    _this2.formData.items.quotation.card_type = savedCardType;
                  });
                }
              }
              // 初审佣金核算方式默认系统核算，人工核算由复审填写
              if (_this2.isFirstApproval && !quotation.accounting_method) {
                _this2.formData.items.quotation.accounting_method = '1';
              }
              _this2.$nextTick(function () {
                _this2.$refs.auditForm && _this2.$refs.auditForm.clearValidate();
              });
            case 6:
              _context.p = 6;
              _this2.loading = false;
              return _context.f(6);
            case 7:
              return _context.a(2);
          }
        }, _callee, null, [[1,, 6, 7]]);
      }))();
    },
    // 打开抽屉后拉取两个历史订单 tab 的数量
    fetchHistoryTotals: function fetchHistoryTotals() {
      var _this3 = this;
      if (!this.saleProjectDeliveryId) return;
      var baseParams = {
        sale_project_delivery_id: this.saleProjectDeliveryId,
        page: 1,
        pagesize: this.historySearchForm.pagesize
      };
      getAuditProjectDeliverOrderList(_objectSpread(_objectSpread({}, baseParams), {}, {
        is_same_type: 1
      })).then(function (res) {
        _this3.sameOrderTotal = res.pages && res.pages.totalCount || 0;
      });
      getAuditProjectDeliverOrderList(_objectSpread(_objectSpread({}, baseParams), {}, {
        is_same_type: 0
      })).then(function (res) {
        _this3.otherOrderTotal = res.pages && res.pages.totalCount || 0;
      });
    },
    handleTabClick: function handleTabClick(tab) {
      if (tab.name === 'projectDetail') {
        this.projectDetailLoaded = true;
        return;
      }
      if (['sameOrder', 'otherOrder'].includes(tab.name)) {
        this.historySearchForm.page = 1;
        this.historySearchForm.sort = '';
        this.getHistoryList();
      }
    },
    getHistoryList: function getHistoryList() {
      var _this4 = this;
      if (!this.saleProjectDeliveryId) return;
      getAuditProjectDeliverOrderList({
        sale_project_delivery_id: this.saleProjectDeliveryId,
        is_same_type: this.activeTab === 'sameOrder' ? 1 : 0,
        page: this.historySearchForm.page,
        pagesize: this.historySearchForm.pagesize,
        sort: this.historySearchForm.sort
      }).then(function (res) {
        _this4.historyTableData = res.data && res.data.list || [];
        _this4.historyPages = res.pages || {};
      });
    },
    historyPageChange: function historyPageChange(val) {
      this.historySearchForm.page = val;
      this.getHistoryList();
    },
    historySortChange: function historySortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.historySearchForm.sort = "".concat(order === 'ascending' ? '' : '-').concat(prop);
      this.getHistoryList();
    },
    emitToTend: function emitToTend(row) {
      this.trendParams = {
        is_total: 0,
        order_id: row.id,
        searchData: {
          gross_profit_type: '2'
        }
      };
      this.drawerTrend = true;
    },
    getBusinessTypeList: function getBusinessTypeList(data) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getBusinessType(data);
            case 1:
              res = _context2.v;
              _this5.businessTypeList = res.data || [];
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getDefaultTimeLimit: function getDefaultTimeLimit() {
      var date = new Date();
      date.setDate(date.getDate() + 30);
      return parseTime(date, '{y}-{m}-{d}');
    },
    // 切换业务类型后重置卡类型并拉取对应卡类型选项
    changeBusinessType: function changeBusinessType() {
      var _this6 = this;
      var val = this.formData.items.quotation.business_type;
      this.formData.items.quotation.card_type = '';
      if (!val) {
        this.quotationCardTypeList = [];
        return;
      }
      getAddOrderCardType({
        business_id: val
      }).then(function (res) {
        _this6.quotationCardTypeList = res.data || [];
      });
    },
    // 拉取卡类型佣金信息：系统核算时填充佣金比例/计入业绩；返回的审核级别用于复审字段名标红
    loadQuotationCommissionInfo: function loadQuotationCommissionInfo() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _this7$formData$items, card_type, final_quotation, params, res, current, info, missing, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _this7$formData$items = _this7.formData.items.quotation, card_type = _this7$formData$items.card_type, final_quotation = _this7$formData$items.final_quotation;
              if (card_type) {
                _context3.n = 1;
                break;
              }
              _this7.quotationCommissionInfo = {};
              return _context3.a(2);
            case 1:
              params = {
                bid_id: card_type,
                single_point: final_quotation
              };
              if (_this7.isSecondApproval) {
                params.source = 'review';
              }
              _context3.p = 2;
              _context3.n = 3;
              return getProjectDeliveryCardTypeInfo(params);
            case 3:
              res = _context3.v;
              current = _this7.formData.items.quotation; // 请求期间卡类型或折扣已变化时丢弃本次结果
              if (!(current.card_type !== card_type || current.final_quotation !== final_quotation)) {
                _context3.n = 4;
                break;
              }
              return _context3.a(2);
            case 4:
              _this7.quotationCommissionInfo = res.data || {};
              if (!(current.accounting_method !== '1')) {
                _context3.n = 5;
                break;
              }
              return _context3.a(2);
            case 5:
              info = _this7.quotationCommissionInfo; // -1 表示禁止销售：清空两个字段，留空由复审手填
              if (!(Number(info.commission) === -1 || Number(info.performance) === -1)) {
                _context3.n = 6;
                break;
              }
              _this7.clearQuotationCommission();
              return _context3.a(2);
            case 6:
              // 接口未返回佣金数据（字段缺失）时保持已有值，避免误清
              missing = function missing(value) {
                return value === undefined || value === null || value === '';
              };
              if (!(missing(info.commission) || missing(info.performance))) {
                _context3.n = 7;
                break;
              }
              return _context3.a(2);
            case 7:
              _this7.formData.items.quotation.commission = info.commission;
              _this7.formData.items.quotation.performance = info.performance;
              _context3.n = 9;
              break;
            case 8:
              _context3.p = 8;
              _t2 = _context3.v;
            case 9:
              return _context3.a(2);
          }
        }, _callee3, null, [[2, 8]]);
      }))();
    },
    clearQuotationCommission: function clearQuotationCommission() {
      this.formData.items.quotation.commission = '';
      this.formData.items.quotation.performance = '';
    },
    // 切换佣金核算方式：人工核算时佣金信息置 0.00，系统核算重拉默认值
    handleAccountingMethodChange: function handleAccountingMethodChange(val) {
      if (val === '2') {
        this.formData.items.quotation.commission = '0.00';
        this.formData.items.quotation.performance = '0.00';
      } else if (val === '1') {
        this.loadQuotationCommissionInfo();
      }
    },
    // 金额类输入过滤（大于等于0，默认最多两位小数，可传 maxDecimals 覆盖）
    handleAmountInput: function handleAmountInput(field) {
      var maxDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var maxIntegerDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 9;
      var raw = String(this.formData.items.quotation[field] || '');
      var cleaned = raw.replace(/[^\d.]/g, '');
      var dotIndex = cleaned.indexOf('.');
      var integerPart = '';
      var decimalPart = '';
      if (dotIndex === -1) {
        integerPart = cleaned;
      } else {
        integerPart = cleaned.slice(0, dotIndex);
        decimalPart = cleaned.slice(dotIndex + 1).replace(/\./g, '');
      }
      integerPart = integerPart.slice(0, maxIntegerDigits);
      decimalPart = decimalPart.slice(0, maxDecimals);
      var nextValue = integerPart;
      if (dotIndex !== -1) {
        nextValue = "".concat(integerPart, ".").concat(decimalPart);
      }
      this.formData.items.quotation[field] = nextValue;
    },
    handleNumberInput: function handleNumberInput() {
      this.formData.items.quotation.number = String(this.formData.items.quotation.number || '').replace(/[^\d]/g, '');
    },
    calcBudget: function calcBudget() {
      var _this$formData$items$2 = this.formData.items.quotation,
        money = _this$formData$items$2.money,
        number = _this$formData$items$2.number;
      if (money === '' || number === '' || Number(number) <= 0) return;
      this.formData.items.quotation.budget = (Number(money) / Number(number)).toFixed(2);
    },
    calcMoney: function calcMoney() {
      var _this$formData$items$3 = this.formData.items.quotation,
        budget = _this$formData$items$3.budget,
        number = _this$formData$items$3.number;
      if (budget === '' || number === '' || Number(number) <= 0) return;
      this.formData.items.quotation.money = (Number(budget) * Number(number)).toFixed(2);
    },
    handleAudit: function handleAudit(audit) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var valid, confirmed;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (!_this8.submitLoading) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              if (!(audit === 1)) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return _this8.$refs.auditForm.validate().catch(function () {
                return false;
              });
            case 2:
              valid = _context4.v;
              if (valid) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2);
            case 3:
              _context4.n = 4;
              return _this8.$confirm(audit === 1 ? '确定审批通过？' : '确定审批驳回？', '提示', {
                type: 'warning'
              }).catch(function () {
                return false;
              });
            case 4:
              confirmed = _context4.v;
              if (confirmed) {
                _context4.n = 5;
                break;
              }
              return _context4.a(2);
            case 5:
              _this8.submitLoading = true;
              _context4.p = 6;
              _context4.n = 7;
              return auditQuotationApproval({
                id: _this8.id,
                project_name: _this8.formData.project_name,
                quotation: _this8.formData.items.quotation,
                audit: audit
              });
            case 7:
              _this8.$message.success(audit === 1 ? '审批通过' : '审批驳回');
              _this8.$emit('update:visible', false);
            case 8:
              _context4.p = 8;
              _this8.submitLoading = false;
              return _context4.f(8);
            case 9:
              return _context4.a(2);
          }
        }, _callee4, null, [[6,, 8, 9]]);
      }))();
    },
    handleDrawerClose: function handleDrawerClose() {
      this.$emit('close');
      this.$emit('update:visible', false);
    }
  }
};